import { NgModule } from '@angular/core';
import { CommonreqLibraryComponent } from './commonreq-library.component';



@NgModule({
  declarations: [CommonreqLibraryComponent],
  imports: [
  ],
  exports: [CommonreqLibraryComponent]
})
export class CommonreqLibraryModule { }
